// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"950c5e0cdc09131dfe3b","936":"6309f5777d6da39a5728"}[chunkId] + ".js";
};